export default {
  summary_one: '{{count}} produkt został usunięty · niedostępny w wybranej godzinie odbioru',
  summary_few: '{{count}} produkty zostały usunięte · niedostępne w czasie Twojego odbioru',
  summary_many: '{{count}} produktów zostało usuniętych · niedostępne w czasie Twojego odbioru',
  summary_other: '{{count}} produkty zostały usunięte · niedostępne w wybranej godzinie odbioru',
  reason: 'Dostępne tylko {{schedule}} — odbiór zaplanowany na {{time}}.',
  change_pickup_time: 'Zmień godzinę odbioru',
  dismiss: 'Zamknij',
};
